import moment from "moment";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useFormState, useField } from "react-final-form";

const AcademicYearInput = ({ parentCallback, isActive }: any) => {
  const { values } = useFormState();
  const academicTerm = useField("academicTermId");
  const date = useField("date");
  const startedAt = useField("startedAt");
  const endedAt = useField("endedAt");

  return (
    <ReferenceInput
      label="Academic Year"
      source="academicYearId"
      reference="academicYears"
      filter={
        isActive
          ? {
              SchoolId: values.schoolId ? parseInt(values.schoolId) : 0,
              Date: moment().format("Y-MM-DD"),
            }
          : {
              SchoolId: values.schoolId ? parseInt(values.schoolId) : 0,
              StatusIn: ["Active", "Ready"],
            }
      }
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
        academicTerm.input.onChange("");
        date.input.onChange("");

        startedAt.input.onChange("");
        endedAt.input.onChange("");
      }}
      validate={required()}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  );
};

export default AcademicYearInput;
